import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.019 5.94h-.5c-.696-1.956-2.092-3.618-3.886-4.693C11.539.074 9.147-.317 6.853.27 4.463.954 2.569 2.42 1.273 4.375.075 6.428-.323 8.775.275 11.023c.997 3.91 4.585 6.647 8.672 6.647h8.972c3.29 0 5.98-2.64 5.98-5.865a5.856 5.856 0 0 0-5.88-5.866m0 9.775H9.047c-3.19 0-5.981-2.15-6.78-5.083-.497-1.858-.198-3.617.799-5.28.997-1.66 2.492-2.736 4.286-3.127.499-.098 1.097-.196 1.695-.196 3.09 0 5.98 2.053 6.779 5.181.1.391.498.782.997.782h1.196c2.193 0 3.987 1.76 3.987 3.91 0 2.054-1.794 3.813-3.987 3.813"
    }, null, -1)
  ]))]))
}
export default { render: render }